__turbopack_context__.v({
  "blockTitle": "MapSection-module__J4xUkW__blockTitle",
  "card": "MapSection-module__J4xUkW__card",
  "grid": "MapSection-module__J4xUkW__grid",
  "head": "MapSection-module__J4xUkW__head",
  "iframe": "MapSection-module__J4xUkW__iframe",
  "link": "MapSection-module__J4xUkW__link",
  "mapCard": "MapSection-module__J4xUkW__mapCard",
  "mapHint": "MapSection-module__J4xUkW__mapHint",
  "mapPin": "MapSection-module__J4xUkW__mapPin",
  "mapPlaceholder": "MapSection-module__J4xUkW__mapPlaceholder",
  "primary": "MapSection-module__J4xUkW__primary",
  "rowGap": "MapSection-module__J4xUkW__rowGap",
  "secondary": "MapSection-module__J4xUkW__secondary",
  "section": "MapSection-module__J4xUkW__section",
  "sub": "MapSection-module__J4xUkW__sub",
  "text": "MapSection-module__J4xUkW__text",
  "title": "MapSection-module__J4xUkW__title",
});
